import React from 'react';
import Slider from 'react-slick';
import { NavLink } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './CakeCarousel.css';
import { NextArrow, PrevArrow } from './CustomArrows';
import ImageModal from '../ImageModal';
import { useCakes } from '../../context/CakesContext';

const CakeCarousel = () => {
  const { loading, error, getCarouselCakes } = useCakes();
  const [selectedCake, setSelectedCake] = React.useState(null);

  // Get carousel cakes from shared context (no separate API call needed)
  const cakes = getCarouselCakes(10);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
          arrows: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          arrows: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          arrows: false,
          dots: true,
        }
      },
    ],
  };

  if (loading) {
    return <section className="carousel-section"><p>Loading cakes...</p></section>;
  }

  if (error) {
    return <section className="carousel-section"><p>Error loading cakes: {error}</p></section>;
  }

  const handleNext = () => {
    const currentIndex = cakes.findIndex(c => c.id === selectedCake.id);
    const nextIndex = (currentIndex + 1) % cakes.length;
    setSelectedCake(cakes[nextIndex]);
  };

  const handlePrev = () => {
    const currentIndex = cakes.findIndex(c => c.id === selectedCake.id);
    const prevIndex = (currentIndex - 1 + cakes.length) % cakes.length;
    setSelectedCake(cakes[prevIndex]);
  };

  return (
    <section className="carousel-section">
      <div className="carousel-container">
        {cakes.length > 0 ? (
          <Slider {...settings}>
            {cakes.map(cake => (
              <div key={cake.id} className="cake-slide">
                <div 
                  className="cake-card"
                  onClick={() => setSelectedCake(cake)}
                  onDoubleClick={() => setSelectedCake(cake)}
                  style={{ cursor: 'pointer' }}
                >
                  <img 
                    src={cake.src} 
                    alt={cake.alt} 
                    className="cake-image"
                    loading="lazy"
                  />
                  <div className="cake-info">
                    <h3 className="cake-name">{cake.name}</h3>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <p>No cakes to display at the moment.</p>
        )}
      </div>
      <div className="section-footer">
        <NavLink to="/gallery" className="view-all-btn">View All Creations</NavLink>
      </div>
      
      {/* Modal for selected cake - using same component as gallery */}
      {selectedCake && (
        <ImageModal 
          cake={selectedCake} 
          onClose={() => setSelectedCake(null)} 
          onNext={handleNext} 
          onPrev={handlePrev} 
        />
      )}
    </section>
  );
};

export default CakeCarousel;
